module.exports = __webpack_public_path__ + "img/w3_trash_recover_light.4ba0088b.png";